import {
  Box,
  Button,
  CopyToClipboard,
  Inline,
  Modal,
  type ModalProps,
  Stack,
  Typography,
} from '@omnipresentgroup/design-system';
import { useCompany } from '@omnipresentgroup/domains';

import { useManagerUser } from '../../../hooks';

type MergeCopyMagicLinkActionModalProps = {
  modalProps: Omit<ModalProps, 'children'>;
  handleClose: () => void;
  magicLink: string;
};

const TITLE = 'Action required';
const DESCRIPTION =
  'Send this URL to your user to authorise their integration.';
const LINK_EXPIRATION_DESCRIPTION = 'This URL will expire after 7 days.';
const MAGIC_LINK_LABEL = 'Magic link URL';
const getMagicLinkLabel = (companyName?: string) =>
  companyName ? `${MAGIC_LINK_LABEL} for ${companyName}` : MAGIC_LINK_LABEL;

export const MergeCopyMagicLinkActionModal = ({
  magicLink,
  modalProps,
  handleClose,
}: MergeCopyMagicLinkActionModalProps) => {
  const { companyId } = useManagerUser();
  const { data: company } = useCompany({
    id: companyId,
    enabled: !!companyId,
  });
  return (
    <Modal {...modalProps} span={2}>
      <Modal.Header title={TITLE} onClose={handleClose} />
      <Modal.Body>
        <Stack gap="12">
          <Stack gap="4">
            <Typography as="span" size="14">
              {DESCRIPTION}
            </Typography>
            <Typography as="span" size="14">
              {LINK_EXPIRATION_DESCRIPTION}
            </Typography>
          </Stack>

          <Stack gap="4">
            <Typography as="label" size="14" weight="medium">
              {getMagicLinkLabel(company?.name)}
            </Typography>
            <Box bg="hover" radius="s" p="8">
              <Inline gap="4" align="center" justify="space-between">
                <Typography as="span" size="14" ellipsis>
                  {magicLink}
                </Typography>
                <Inline gap="4">
                  <CopyToClipboard textToCopy={magicLink} />
                  <Button
                    icon="ExternalLink"
                    variant="tertiary"
                    size="small"
                    onClick={() => window.open(magicLink, '_blank')}
                  />
                </Inline>
              </Inline>
            </Box>
          </Stack>
        </Stack>
      </Modal.Body>
    </Modal>
  );
};
